import {
  ProtocolMode,
  Configuration,
  RedirectRequest,
  PublicClientApplication,
  BrowserCacheLocation
} from "@azure/msal-browser";

import { InteractionRequiredAuthError } from "@azure/msal-browser";

const scopes = [
  "openid",
  "profile",
  "offline_access",
  `wib-api-${process.env.WIB_WORKSPACE_ID}`
];

export const redirectRequest: RedirectRequest = {
  scopes,
  redirectUri: `${window.location.origin}/auth/login`
};

export const msalConfig: Configuration = {
  auth: {
    clientId: `wib-js-${process.env.WIB_WORKSPACE_ID}`,
    authority: process.env.WIB_AUTH_URL,
    protocolMode: ProtocolMode.OIDC,
    knownAuthorities: [process.env.WIB_AUTH_URL]
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage
  }
};

export const msalInstance = new PublicClientApplication(msalConfig);

export async function getActiveAccountAccessToken() {
  const activeAccount = msalInstance.getActiveAccount();

  if (!activeAccount) {
    await msalInstance.loginRedirect(redirectRequest);
    return;
  }

  try {
    const accessToken = await msalInstance.acquireTokenSilent({
      account: activeAccount,
      scopes
    });

    if (!accessToken) {
      throw new Error("no token received");
    }

    return accessToken;
  } catch (error) {
    // if silent fails, fall back to redirect
    if (error instanceof InteractionRequiredAuthError) {
      await msalInstance.acquireTokenRedirect({
        account: activeAccount,
        scopes
      });
      return;
    }
    // additional "non-interaction" errors 
    throw error;
  }
}
